// FCS (first customer shipment) build switch. Features that are not fully
// fleshed out yet are hidden from the User Area while REACT_APP_FCS is
// exactly "true"; unset or any other value shows everything. The flag is
// resolved at build time (CRA inlines process.env), so a change means a
// rebuild + redeploy of the web app, never a runtime toggle.
//
// The derived per-feature constants are what components consult, so a
// feature can later graduate from FCS on its own (flip one line here).
const FCS = process.env.REACT_APP_FCS === "true"

// Rent-to-Own: sidebar item, /plan route + page, Dashboard card, the
// bonus-trial-days offer (it starts a subscription) and origin links.
export const RENT_TO_OWN_ENABLED = !FCS

// Reward Points: sidebar item, /points route + page, the balance pill and
// the "Redeem with points" offers.
export const REWARD_POINTS_ENABLED = !FCS

// Bundle upgrade offers on Your Offers (and the Dashboard teaser).
export const UPGRADE_OFFERS_ENABLED = !FCS

// Crossgrade offers (personalized one-time prices earned by owned products) on
// Your Offers, the Store and the Dashboard teaser. Deliberately NOT tied to
// FCS: vendors configure these for production customers.
export const CROSSGRADE_OFFERS_ENABLED = true

// TEMPORARY (2026-10-20): the Your Offers page is withdrawn for customers —
// sidebar item, /offers route (→ Dashboard) and the Dashboard teaser that
// links to it. System-wide admins keep it (useOffersPageEnabled in
// offersAccess.ts). Not tied to FCS; flip back to true to restore it for all.
export const OFFERS_PAGE_ENABLED = false

